<template>
    <template-layout>
        <div class="py-12 px-4">
            <nav class="mb-2 flex justify-between">
                <h1 class="text-2xl text-theme-1">
                จัดการข้อมูล CM ภายใต้ HCM
                </h1>
                <!-- <HcmFormModal v-if="showHcmModal" :hcm_user="showHcmModal[0].hcm" @closeModal="handleCloseModal"/> -->
                <HcmFormModal v-if="showHcmModalComputed" :hcm_user="showHcmModalComputed"  @closeModal="reloadTable = $event ? true : false" @openModal="reloadTable = false"/>
            </nav>
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 md:col-span-4 lg:col-span-3">
                    <HcmUsersFilter />
                </div>
                <div class="col-span-12 md:col-span-8 lg:col-span-9">
                    <FilterSummary :items="filterSummaryStore"/>
                    <HcmDatatable :filter="filterValue" @showHcmModal="showHcmModal=$event" :reloadTable="reloadTable"/>
                </div>
            </div>
        </div>
    </template-layout>
</template>

<script setup>
import { ref, computed, reactive } from "vue";
import TemplateLayout from "@/layouts/side-menu/Main.vue";
import FilterSummary from "@/components/filter-summary/index.vue";
import HcmUsersFilter from "@/components/filter-search/HcmUsersFilter.vue"
import HcmDatatable from "./container/HCMDatatable.vue";
import HcmFormModal from "./container/UserHcmFormModal.vue";
import Swal from "sweetalert2"
import { useStore } from "vuex";

const store = useStore();
const filterSummaryStore = computed(
  () => store.getters["hcmUserFilter/getFilterSummaryArray"]
);
const filterValue = computed(() => store.getters["hcmUserFilter/getFilterForApi"]);

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})


const breadcrumbComputed = reactive([{
  name: "จัดการข้อมูล CM ภายใต้ HCM",
  active: true
}])
const showHcmModal = ref(null)
const reloadTable = ref(false);

const showHcmModalComputed = computed(()=>{
    if(filterValue.value.hcm_uid?.startsWith("hcm")){
        if(showHcmModal.value?.length > 0){
            return showHcmModal.value[0].hcm
        }else{
            return { uid: filterValue.value.hcm_uid }
        }
    }
    return null
})

</script>

<style>

</style>